import React from "react";
import { Bar } from "react-chartjs-2";

const OrdersByCurrency = ({ data }) => {
	const lineChartData = () => {
		let datasets = [];
		let colors = { MYR: "red", PHP: "orange", IDR: "blue", USD: "green", EUR: "yellow", TBH: "black", GBP: "darkred", AUD: "#89d129", SGD: "darkyellow", INR: "#763565", Others: "#002929" };
		let labels = ["FlightOTA", "Food", "Hotel", "Deal", "AARide"];
		let currencies = ["MYR", "PHP", "IDR", "USD", "EUR", "TBH", "GBP", "AUD", "SGD", "INR", "Others"];
		currencies.forEach((c) => {
			let curData = [];
			labels.forEach((lob) => {
				curData.push(data[lob][c]);
			});
			datasets.push({
				label: c,
				backgroundColor: colors[c],
				data: curData,
				borderWidth: 1,
				lineTension: 0,
				elements: { point: { radius: 1 } },
				stack: "C",
			});
		});

		return {
			labels: labels,
			datasets: datasets,
		};
	};

	return (
		<Bar
			data={lineChartData()}
			options={{
				backgroundColor: "orange",
				borderColor: "black",
				color: "green",
				responsive: true,
				maintainAspectRatio: false,
				interaction: {
					intersect: false,
				},
				scales: {
					x: {
						stacked: true,
					},
					y: {
						stacked: true,
					},
				},
				plugins: {
					legend: {
						display: false,
					},
				},
			}}
		/>
	);
};

export default OrdersByCurrency;
